import Api from '../../services/api';
import variables from '../../assets/stylesheet/variables.scss';

const companyStore = {
  namespaced: true,
  state: {
    currentScopedCompany: {},
    currentScopedCompanyConfigImage: {},
    currentScopedCompanyPage: {},
    currentScopedCompanySubdomain: {},
    currentScopedCompanyCustomers: null,
    currentScopedCompanyCustomerContacts: null,
    isCompanyLoading: false,
  },
  mutations: {
    SET_LOADING(state, value) {
      state.isCompanyLoading = value;
    },
    SET_CURRENT_SCOPED_COMPANY(state, value) {
      state.currentScopedCompany = value;
    },
    SET_CURRENT_SCOPED_COMPANY_CONFIG_IMAGE(state, value) {
      state.currentScopedCompanyConfigImage = value;
    },
    SET_CURRENT_SCOPED_COMPANY_PAGE(state, value) {
      state.currentScopedCompanyPage = value;
    },
    SET_CURRENT_SCOPED_COMPANY_SUBDOMAIN(state, value) {
      state.currentScopedCompanySubdomain = value;
    },
    SET_CURRENT_SCOPED_COMPANY_CUSTOMERS(state, value) {
      state.currentScopedCompanyCustomers = value;
    },
    SET_CURRENT_SCOPED_COMPANY_CUSTOMER_CONTACTS(state, value) {
      state.currentScopedCompanyCustomerContacts = value;
    },
  },
  actions: {
    async loadCurrentScopedCompanyCustomers({ commit }, { company_id, q }) {
      commit('SET_LOADING', true);
      const params = { company_id, q };
      await Api().get('/customers', {
        params,
      })
        .then((response) => {
          const { data, included } = response.data;
          commit('SET_CURRENT_SCOPED_COMPANY_CUSTOMERS', data.map((customer) => ({
            name: customer.attributes.trading_name,
            id: customer.id.toString(),
            address: { ...included.find((addr) => addr.id === customer?.relationships?.address.data.id).attributes },
          })));
        })
        .catch(() => {
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },
    async loadCurrentScopedCompanyCustomerContacts({ commit }, id) {
      commit('SET_LOADING', true);
      await Api().get('/customer_contacts', {
        params: {
          customer_id: id,
        },
      })
        .then((response) => {
          const { data } = response.data;
          commit('SET_CURRENT_SCOPED_COMPANY_CUSTOMER_CONTACTS', data.map((contact) => ({
            name: contact.attributes.name,
            email: contact.attributes.email,
            phone: contact.attributes.phone,
            role: contact.attributes.role,
            id: contact.id.toString(),
          })));
        })
        .catch(() => {
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },
  },
  getters: {
    isCompanyLoading: (state) => (state.isCompanyLoading),
    getCurrentScopedCompany: (state) => (state.currentScopedCompany),
    hasCurrentScopedCompany: (state) => (_.has(state.currentScopedCompany, 'id')),
    currentScopedCompanyManagerOther: (state) => (!!state.currentScopedCompany.manage_other),
    currentScopedCompanyParent: (state) => (!!state.currentScopedCompany.parent),
    currentScopedCompanyHasImages: (state) => (!_.isEmpty(state.currentScopedCompanyConfigImage)),
    currentScopedCompanyHasVideo: (state) => (!_.isEmpty(state.currentScopedCompanyPage.video_url)),
    getCurrentScopedCompanyCustomers: (state) => (state.currentScopedCompanyCustomers),
    getCurrentScopedCompanyCustomerContacts: (state) => (state.currentScopedCompanyCustomerContacts),
    getCurrentScopedCompanyPage: (state) => (state.currentScopedCompanyPage),
    getCurrentScopedCompanySubdomain: (state) => (state.currentScopedCompanySubdomain),
    getShortScopedCompanyName: (state) => {
      let name;
      if (state.currentScopedCompany) {
        name = state.currentScopedCompany.name;
      } else {
        name = 'Carregando...';
      }
      return name.length > 15 ? `${name.substring(0, 12)}...` : name;
    },
    getHeaderImage: (state) => {
      if (state.currentScopedCompanyPage.header_image) {
        return state.currentScopedCompanyPage.header_image.url;
      }
      return require('../../assets/landings/thumb/15.jpg');
    },
    getPrimaryColor: (state) => {
      if (state.currentScopedCompanyPage.primary_color) {
        return state.currentScopedCompanyPage.primary_color;
      }
      return variables.abler_primary;
    },
    getSecondaryColor: (state) => {
      if (state.currentScopedCompanyPage.secondary_color) {
        return state.currentScopedCompanyPage.secondary_color;
      }
      return variables.abler_primary;
    },
  },
};

export default companyStore;
